export default class RemovedOutcomesModifier {
    constructor(modelKeyRepository) {
        this._modelKeyRepository = modelKeyRepository;
    }

    modify(content) {
        if (content.outcomes === undefined) {
            return;
        }

        const outcomes = content.outcomes.remove;

        if (outcomes !== undefined) {
            for (let i = 0; i < outcomes.length; i++) {
                outcomes[i] = this._modelKeyRepository.removeOutcome(outcomes[i]);
            }
        }
    }
}



// WEBPACK FOOTER //
// ./js/repositories/modifier/RemovedOutcomesModifier.js